import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { UtilService } from '@services/util.service';
import { OAuthStorage } from 'angular-oauth2-oidc';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UserManagementService } from 'src/app/modules/user-management/services/user-management.service';

@Component({
  selector: 'app-modal-choose-country',
  templateUrl: './modal-choose-country.component.html',
  styleUrls: ['./modal-choose-country.component.scss']
})
export class ModalChooseCountryComponent implements OnInit, OnDestroy {

  public chooseCountryForm: FormGroup = new FormGroup({ country: new FormControl(null, Validators.required) });
  private destroyed$: Subject<any> = new Subject();
  public isLoading = false;

  constructor(
    private dialogRef: MatDialogRef<ModalChooseCountryComponent>,
    private authStorage: OAuthStorage,
    private userManagementService: UserManagementService,
    private utilService: UtilService
  ) { }

  ngOnInit(): void {
    const country = this.authStorage.getItem('country');
    if (country) {
      this.chooseCountryForm.get('country').setValue(country);
    }
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  public enter(): void {
    this.isLoading = true;
    this.authStorage.setItem('country', this.chooseCountryForm.get('country').value);
    this.userManagementService.lastAccess().pipe(takeUntil(this.destroyed$)).subscribe(
      res => {
        if (res.success) {
          this.dialogRef.close(this.chooseCountryForm.get('country').value);
        } else {
          this.utilService.toastErrors(res);
        }
        this.isLoading = false;
      },
      error => {
        this.utilService.toastErrors(error);
        this.isLoading = false;
      }
    );
  }

}
